import ServiceCategories from './ServiceCategories';
import { Sparkles } from 'lucide-react';
const Services = () => {
  return <section id="services" className="py-12 px-4 bg-gradient-to-br from-gray-50 via-blue-light/30 to-green-light/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-primary/5 via-transparent to-green-primary/5"></div>
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-2 h-2 bg-gradient-blue-green rounded-full animate-pulse"></div>
            <Sparkles className="text-blue-primary animate-pulse" size={20} />
            <div className="w-2 h-2 bg-gradient-blue-green rounded-full animate-pulse"></div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-primary to-green-primary bg-clip-text text-transparent mb-3">
            Our Testing Services
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto">Mobile testing services that come to you,  secure, reliable, and convenient</p>
          <div className="w-20 h-1 bg-gradient-blue-green mx-auto mt-3 rounded-full"></div>
        </div>

        {/* Service Categories */}
        <ServiceCategories />
      </div>
    </section>;
};
export default Services;